import { Formik } from "formik";
import {
  Grid,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormControlLabel,
  Switch,
  FormHelperText,
} from "@mui/material";

import SubmitButton from "components/Button/SubmitButton";
import { referringProviderSchema } from "schemas/referringProviderSchema";
import states from "components/pages/transmissions/modal/patient/static/states";
import useReferringProviderForm from "../hooks/useReferringProviderForm";

const ReferringProviderForm = () => {
  const {
    initialReferringProviderValues,
    isProcessing,
    accounts,
    handleFormSubmit,
    handleModalClose,
  } = useReferringProviderForm();

  return (
    <Formik
      enableReinitialize
      initialValues={{ ...initialReferringProviderValues }}
      validationSchema={referringProviderSchema}
      onSubmit={handleFormSubmit}
    >
      {({ handleSubmit, touched, errors, values, handleChange }) => (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                margin="none"
                required
                value={values.name}
                label="Name"
                error={touched.name && Boolean(errors.name)}
                onChange={handleChange("name")}
                helperText={touched.name && errors.name}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                margin="none"
                required
                value={values.npi}
                label="NPI"
                error={touched.npi && Boolean(errors.npi)}
                onChange={handleChange("npi")}
                helperText={touched.npi && errors.npi}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined" required>
                <InputLabel id="demo-simple-select-label">Account</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="account"
                  required={true}
                  name="account"
                  value={values?.account}
                  onChange={handleChange("account")}
                  input={<OutlinedInput fullWidth label="account" />}
                  error={touched.account && Boolean(errors.account)}
                  helperText={touched.account && errors.account}
                >
                  {accounts.map((account, index) => (
                    <MenuItem key={index} value={account?.name}>
                      {account?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {touched.account && Boolean(errors.account) && (
                <FormHelperText error>{errors.account} </FormHelperText>
              )}
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                margin="none"
                value={values.street}
                label="Street Address"
                error={touched.street && Boolean(errors.street)}
                onChange={handleChange("street")}
                helperText={touched.street && errors.street}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined">
                <InputLabel id="demo-simple-select-label">State</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="state"
                  name="state"
                  value={values?.state}
                  onChange={handleChange("state")}
                  input={<OutlinedInput fullWidth label="State" />}
                  error={touched.state && Boolean(errors.state)}
                >
                  {states.map((state, index) => (
                    <MenuItem key={index} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                margin="none"
                value={values.zip}
                label="Zip"
                error={touched.zip && Boolean(errors.zip)}
                onChange={handleChange("zip")}
                helperText={touched.zip && errors.zip}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    defaultChecked={values?.default}
                    onChange={handleChange("default")}
                    color="secondary"
                  />
                }
                labelPlacement="start"
                label="Default Provider"
                style={{ marginLeft: 0 }}
              />
            </Grid>
          </Grid>

          <div
            className="d-flex flex-end"
            style={{ gap: "10px", marginTop: 15 }}
          >
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleModalClose}
              disabled={isProcessing}
            >
              Cancel
            </Button>

            <SubmitButton
              variant="contained"
              color="secondary"
              handleClick={handleSubmit}
              isLoading={isProcessing}
            />
          </div>
        </>
      )}
    </Formik>
  );
};

export default ReferringProviderForm;
